// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E8yIYDdVWlypW14FhPz9 {
  width: 100%;
  height: 100vh;
  background: #f7f7f7;
  margin: 0 auto;
  font-family: "Arial", sans-serif;
}
.Vu7v64zbyHxHZwPquoSi {
  font-size: 16px;
  color: #fff;
  background-color: #79c9e3;
  padding: 10px 20px;
  text-align: center;
}
.vUswtBIQjxQuZ2vf758Z {
  height: calc(100vh - 45px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  background: #f7f7f7;
}
.ol5xVY1dNiW1fOOpII90 {
  width: 100%;
  background: linear-gradient(180deg, #79c9e3, #eaf5f5);
  padding: 25px 20px 20px;
  box-sizing: border-box;
}
.ol5xVY1dNiW1fOOpII90 .wugq3uqxYFgKclVT20Ox {
  font-size: 20px;
  font-weight: 700;
  color: #115069;
  margin-bottom: 10px;
}
.ol5xVY1dNiW1fOOpII90 p {
  font-size: 14px;
  color: #1f5b73;
  margin: 0;
}
.QAoumhGgOdhfnpNpKSsr {
  flex: 1;
  overflow-y: auto;
  background: #f7f7f7;
  padding: 20px;
}
.O8zNI6xSSmG2J7OqDSmb {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  list-style: none;
}
.kKUI1vqGeIeMJqFUBQHf {
  align-items: center;
  list-style: disc;
  margin-left: 10px;
  margin-bottom: 20px;
}
.kKUI1vqGeIeMJqFUBQHf::marker {
  color: #79c9e3;
  font-size: 20px;
  line-height: 1;
}
.kKUI1vqGeIeMJqFUBQHf .m6FLmbimR_4ULHmGaNmE {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  min-width: 100px;
  margin-bottom: 10px;
}
.kKUI1vqGeIeMJqFUBQHf .dhuoYdv6V3YxhqV9dXra {
  flex: 1;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px 15px 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}
.kKUI1vqGeIeMJqFUBQHf .dhuoYdv6V3YxhqV9dXra .tBIl8CGjZCbBqEuG8zV2 {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0 0 10px 0;
}
.kKUI1vqGeIeMJqFUBQHf .dhuoYdv6V3YxhqV9dXra .mZhJZXTiAAGFt2rYQ5Ef {
  border: 0;
  border-top: 1px solid #e0e0e0;
  margin: 10px 0;
}
.kKUI1vqGeIeMJqFUBQHf .dhuoYdv6V3YxhqV9dXra .D_TfEFd93p0OWgoK6vVr {
  font-size: 14px;
  color: #444;
  margin: 0;
}
.kKUI1vqGeIeMJqFUBQHf .dhuoYdv6V3YxhqV9dXra .oGTatrtuUDOvucDBry8e {
  color: #bababa;
  font-size: 12px;
  margin-top: 10px;
}
.ant-modal .ant-modal-footer > .ant-btn + .ant-btn {
  margin-inline-start: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/PhoneReport/components/styles/userReport.module.less"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;AAAF;AAGA;EACE,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAKA;EACE,0BAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAHF;AAOA;EACE,WAAA;EACA,qDAAA;EACA,uBAAA;EACA,sBAAA;AALF;AACA;EAOI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AALJ;AALA;EAcI,eAAA;EACA,cAAA;EACA,SAAA;AANJ;AAWA;EACE,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AATF;AAYA;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAVF;AAcA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAZF;AAcE;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAZJ;AAGA;EAaI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAbJ;AAJA;EAqBI,OAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yCAAA;AAdJ;AAXA;EA4BM,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAdN;AAjBA;EAmCM,SAAA;EACA,6BAAA;EACA,cAAA;AAfN;AAtBA;EAyCM,eAAA;EACA,WAAA;EACA,SAAA;AAhBN;AA3BA;EA+CM,cAAA;EACA,eAAA;EACA,gBAAA;AAjBN;AAsBA;EAEI,iCAAA;AArBJ","sourcesContent":["// 容器样式\n.container {\n  width: 100%;\n  height: 100vh;\n  background: #f7f7f7;\n  margin: 0 auto;\n  font-family: \"Arial\", sans-serif;\n}\n\n.title {\n  font-size: 16px;\n  color: #fff;\n  background-color: #79c9e3;\n  padding: 10px 20px;\n  text-align: center;\n}\n\n// 云胶片内容部分\n.content {\n  height: calc(100vh - 45px); // 固定高度\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  background: #f7f7f7; // 与页面背景色一致\n}\n\n// 提示部分（设置渐变背景色）\n.header {\n  width: 100%; // 宽度占满父容器\n  background: linear-gradient(180deg, #79c9e3, #eaf5f5); // 渐变背景色\n  padding: 25px 20px 20px; // 内容区域保持 20px 左右内边距\n  box-sizing: border-box; // 确保 padding 不影响宽度计算\n\n  .sectionTitle {\n    font-size: 20px;\n    font-weight: 700;\n    color: #115069;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 14px;\n    color: #1f5b73;\n    margin: 0;\n  }\n}\n\n// 列表部分\n.listWrapper {\n  flex: 1;\n  overflow-y: auto; // 支持滚动，适应多条数据\n  background: #f7f7f7; // 确保背景色一致\n  padding: 20px;\n}\n\n.reportList {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  list-style: none; // 先移除默认样式\n}\n\n// 列表项（圆角白色背景框）\n.reportItem {\n  align-items: center;\n  list-style: disc; // 恢复小圆点样式\n  margin-left: 10px;\n  margin-bottom: 20px;\n\n  &::marker {\n    color: #79c9e3; // 设置小圆点颜色\n    font-size: 20px; // 增大圆点直径\n    line-height: 1; // 确保垂直对齐\n  }\n\n  .itemDate {\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n    min-width: 100px;\n    margin-bottom: 10px;\n  }\n\n  .itemDetails {\n    flex: 1;\n    background-color: #ffffff; // 白色背景\n    border-radius: 10px; // 圆角\n    padding: 15px 15px 5px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n\n    .itemTitle {\n      font-size: 14px;\n      font-weight: 500;\n      color: #333;\n      margin: 0 0 10px 0;\n    }\n\n    .divider {\n      border: 0;\n      border-top: 1px solid #e0e0e0;\n      margin: 10px 0;\n    }\n\n    .hospital {\n      font-size: 14px;\n      color: #444;\n      margin: 0;\n    }\n\n    .itemDay {\n      color: #bababa;\n      font-size: 12px;\n      margin-top: 10px;\n    }\n  }\n}\n\n:global {\n  .ant-modal .ant-modal-footer > .ant-btn + .ant-btn {\n    margin-inline-start: 0 !important;\n  }\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `E8yIYDdVWlypW14FhPz9`,
	"title": `Vu7v64zbyHxHZwPquoSi`,
	"content": `vUswtBIQjxQuZ2vf758Z`,
	"header": `ol5xVY1dNiW1fOOpII90`,
	"sectionTitle": `wugq3uqxYFgKclVT20Ox`,
	"listWrapper": `QAoumhGgOdhfnpNpKSsr`,
	"reportList": `O8zNI6xSSmG2J7OqDSmb`,
	"reportItem": `kKUI1vqGeIeMJqFUBQHf`,
	"itemDate": `m6FLmbimR_4ULHmGaNmE`,
	"itemDetails": `dhuoYdv6V3YxhqV9dXra`,
	"itemTitle": `tBIl8CGjZCbBqEuG8zV2`,
	"divider": `mZhJZXTiAAGFt2rYQ5Ef`,
	"hospital": `D_TfEFd93p0OWgoK6vVr`,
	"itemDay": `oGTatrtuUDOvucDBry8e`
};
export default ___CSS_LOADER_EXPORT___;
